var map = {
	"./$pac.svg": 19427,
	"./0xbtc.svg": 89864,
	"./1inch.svg": 41632,
	"./2give.svg": 63972,
	"./aave.svg": 1686,
	"./abt.svg": 93726,
	"./act.svg": 80369,
	"./actn.svg": 41717,
	"./ada.svg": 64353,
	"./add.svg": 99324,
	"./adx.svg": 33432,
	"./ae.svg": 47297,
	"./aeon.svg": 41946,
	"./aeur.svg": 38064,
	"./agi.svg": 73984,
	"./agix.svg": 20040,
	"./agrs.svg": 41714,
	"./aion.svg": 89054,
	"./aioz.svg": 91362,
	"./akt.svg": 85753,
	"./alcx.svg": 80265,
	"./alex.svg": 72791,
	"./algo.svg": 38770,
	"./ali.svg": 8305,
	"./amb.svg": 43001,
	"./amp.svg": 64299,
	"./ampl.svg": 49941,
	"./ankr.svg": 30693,
	"./ant.svg": 35658,
	"./ape.svg": 13609,
	"./apex.svg": 83811,
	"./api3.svg": 57508,
	"./appc.svg": 65519,
	"./apt.svg": 6600,
	"./ar.svg": 21454,
	"./arb.svg": 91952,
	"./ardr.svg": 83056,
	"./arg.svg": 33085,
	"./ark.svg": 56633,
	"./arn.svg": 80660,
	"./arnx.svg": 66628,
	"./ary.svg": 35403,
	"./ash.svg": 65029,
	"./ast.svg": 84929,
	"./atm.svg": 74693,
	"./atom.svg": 11344,
	"./audio.svg": 33563,
	"./audr.svg": 28959,
	"./auto.svg": 79834,
	"./avax.svg": 70133,
	"./axl.svg": 39320,
	"./axs.svg": 84239,
	"./aywa.svg": 60049,
	"./azero.svg": 12690,
	"./bab.svg": 80334,
	"./bal.svg": 5880,
	"./band.svg": 41642,
	"./bat.svg": 1264,
	"./bay.svg": 97781,
	"./bcbc.svg": 59995,
	"./bcc.svg": 83081,
	"./bcd.svg": 56198,
	"./bch.svg": 73954,
	"./bcio.svg": 54718,
	"./bcn.svg": 31436,
	"./bco.svg": 83245,
	"./bcpt.svg": 99338,
	"./bdl.svg": 62239,
	"./bdx.svg": 16227,
	"./beam.svg": 98782,
	"./bela.svg": 55765,
	"./bix.svg": 21660,
	"./blcn.svg": 37206,
	"./blk.svg": 26632,
	"./block.svg": 32438,
	"./blur.svg": 47328,
	"./blz.svg": 49993,
	"./bnb.svg": 66459,
	"./bnt.svg": 64357,
	"./bnty.svg": 65766,
	"./bond.svg": 54676,
	"./bonk.svg": 11715,
	"./booty.svg": 67804,
	"./bos.svg": 21885,
	"./bpt.svg": 39651,
	"./bq.svg": 5492,
	"./brd.svg": 52809,
	"./bsd.svg": 15190,
	"./bsv.svg": 23396,
	"./btc-det.svg": 936,
	"./btc.svg": 79368,
	"./btcd.svg": 19172,
	"./btch.svg": 86816,
	"./btcp.svg": 94632,
	"./btcz.svg": 45074,
	"./btdx.svg": 69341,
	"./btg.svg": 33556,
	"./btm.svg": 74942,
	"./bts.svg": 84696,
	"./btt.svg": 29623,
	"./btx.svg": 38451,
	"./burst.svg": 31651,
	"./bze.svg": 35408,
	"./cake.svg": 10331,
	"./call.svg": 52411,
	"./cbeth.svg": 23777,
	"./cc.svg": 75033,
	"./cdn.svg": 74300,
	"./cdt.svg": 75302,
	"./celo.svg": 75060,
	"./cenz.svg": 49747,
	"./cfg.svg": 77411,
	"./cfx.svg": 71044,
	"./chain.svg": 76138,
	"./chat.svg": 77809,
	"./chips.svg": 88380,
	"./chr.svg": 35660,
	"./chsb.svg": 29941,
	"./chz.svg": 81156,
	"./cix.svg": 92833,
	"./ckb.svg": 64017,
	"./clam.svg": 85180,
	"./cloak.svg": 40361,
	"./cmm.svg": 4840,
	"./cmt.svg": 66769,
	"./cnd.svg": 27464,
	"./cnx.svg": 63980,
	"./cny.svg": 11341,
	"./cob.svg": 48229,
	"./colx.svg": 21169,
	"./comp.svg": 48798,
	"./coqui.svg": 48860,
	"./core.svg": 16450,
	"./coti.svg": 38104,
	"./cred.svg": 84883,
	"./cro.svg": 62831,
	"./crpt.svg": 25828,
	"./crv.svg": 76358,
	"./crw.svg": 90743,
	"./cs.svg": 93353,
	"./cspr.svg": 28675,
	"./ctc.svg": 48553,
	"./ctr.svg": 38984,
	"./ctsi.svg": 30258,
	"./ctx.svg": 82098,
	"./ctxc.svg": 73853,
	"./cube.svg": 36088,
	"./cvc.svg": 5087,
	"./d.svg": 70809,
	"./dai.svg": 16991,
	"./dao.svg": 87057,
	"./dash.svg": 47223,
	"./dat.svg": 99146,
	"./data.svg": 20375,
	"./dbc.svg": 6920,
	"./dcn.svg": 60238,
	"./dcr.svg": 6058,
	"./deez.svg": 61263,
	"./degen.svg": 34872,
	"./dent.svg": 43640,
	"./deso.svg": 33356,
	"./dew.svg": 5669,
	"./dexe.svg": 76915,
	"./dfi.svg": 58950,
	"./dgb.svg": 63518,
	"./dgd.svg": 24976,
	"./dlt.svg": 74705,
	"./dnt.svg": 58971,
	"./dock.svg": 78862,
	"./dog.svg": 16763,
	"./doge.svg": 36716,
	"./dot.svg": 71352,
	"./dpi.svg": 26248,
	"./drgn.svg": 27514,
	"./drop.svg": 8404,
	"./dta.svg": 948,
	"./dth.svg": 42525,
	"./dtr.svg": 77783,
	"./dusk.svg": 82096,
	"./dydx.svg": 70390,
	"./ebst.svg": 18899,
	"./eca.svg": 82416,
	"./edg.svg": 25523,
	"./edo.svg": 18507,
	"./edoge.svg": 76671,
	"./edu.svg": 98689,
	"./efil.svg": 49405,
	"./egld.svg": 16383,
	"./ela.svg": 63301,
	"./elec.svg": 68664,
	"./elf.svg": 39770,
	"./elix.svg": 70911,
	"./ella.svg": 49585,
	"./elon.svg": 52559,
	"./emb.svg": 93653,
	"./emc.svg": 72020,
	"./emc2.svg": 97998,
	"./eng.svg": 96733,
	"./enj.svg": 19688,
	"./ens.svg": 97969,
	"./entrp.svg": 81680,
	"./eon.svg": 17963,
	"./eop.svg": 55293,
	"./eos.svg": 26846,
	"./eqli.svg": 81908,
	"./equa.svg": 22379,
	"./ern.svg": 85440,
	"./etc.svg": 76783,
	"./eth-det.svg": 67172,
	"./eth.svg": 68372,
	"./ethos.svg": 72594,
	"./ethw.svg": 73427,
	"./ethx.svg": 34884,
	"./etn.svg": 58026,
	"./etp.svg": 73996,
	"./eul.svg": 99851,
	"./eur.svg": 97533,
	"./evx.svg": 44834,
	"./exmo.svg": 55736,
	"./exp.svg": 72256,
	"./fair.svg": 96313,
	"./fct.svg": 8530,
	"./fdusd.svg": 36611,
	"./fet.svg": 40936,
	"./fida.svg": 7229,
	"./fil.svg": 83548,
	"./fjc.svg": 5010,
	"./fldc.svg": 14426,
	"./flo.svg": 73384,
	"./flow.svg": 16263,
	"./flr.svg": 32141,
	"./flux.svg": 5078,
	"./fnsa.svg": 43691,
	"./forth.svg": 54164,
	"./frax.svg": 55072,
	"./fsn.svg": 21608,
	"./ftc.svg": 82788,
	"./ftm.svg": 58690,
	"./fuel.svg": 22511,
	"./fun.svg": 14162,
	"./fxs.svg": 59800,
	"./gal.svg": 67297,
	"./gala.svg": 10146,
	"./game.svg": 77725,
	"./gas.svg": 91942,
	"./gbp.svg": 1244,
	"./gbx.svg": 71860,
	"./gbyte.svg": 32132,
	"./generic.svg": 31998,
	"./gfi.svg": 76961,
	"./gho.svg": 90389,
	"./gin.svg": 60587,
	"./glm.svg": 17803,
	"./glmr.svg": 60051,
	"./glxt.svg": 5990,
	"./gmr.svg": 65387,
	"./gmt.svg": 95045,
	"./gmx.svg": 14449,
	"./gno.svg": 51223,
	"./gnt.svg": 13660,
	"./gold.svg": 23721,
	"./gram.svg": 7490,
	"./grc.svg": 54031,
	"./grin.svg": 53897,
	"./grs.svg": 95647,
	"./grt.svg": 37088,
	"./gsc.svg": 21036,
	"./gt.svg": 89098,
	"./gtc.svg": 19141,
	"./gto.svg": 81073,
	"./gup.svg": 52801,
	"./gusd.svg": 78482,
	"./gvt.svg": 68244,
	"./gxs.svg": 90785,
	"./gzr.svg": 40166,
	"./hbar.svg": 53232,
	"./hight.svg": 72833,
	"./hns.svg": 89184,
	"./hnt.svg": 6655,
	"./hodl.svg": 7904,
	"./hot.svg": 73180,
	"./hpb.svg": 8823,
	"./hsr.svg": 5774,
	"./ht.svg": 82843,
	"./html.svg": 37784,
	"./huc.svg": 13285,
	"./husd.svg": 16499,
	"./hush.svg": 47927,
	"./icn.svg": 24595,
	"./icp.svg": 58741,
	"./icx.svg": 22205,
	"./id.svg": 6952,
	"./ignis.svg": 14263,
	"./ilk.svg": 78171,
	"./ilv.svg": 63534,
	"./imx.svg": 15227,
	"./index.svg": 2977,
	"./inj.svg": 53044,
	"./ink.svg": 25653,
	"./ins.svg": 56557,
	"./ion.svg": 74399,
	"./iop.svg": 5401,
	"./iost.svg": 36586,
	"./iota.svg": 63470,
	"./iotx.svg": 64967,
	"./iq.svg": 23301,
	"./itc.svg": 30395,
	"./jam.svg": 2305,
	"./jasmy.svg": 62633,
	"./jnt.svg": 11005,
	"./joe.svg": 95499,
	"./jpy.svg": 15054,
	"./jst.svg": 9582,
	"./jup.svg": 20912,
	"./kas.svg": 59066,
	"./kava.svg": 45396,
	"./kcs.svg": 44448,
	"./kda.svg": 54243,
	"./keep.svg": 55696,
	"./kin.svg": 82311,
	"./klay.svg": 61752,
	"./klown.svg": 47646,
	"./kmd.svg": 64537,
	"./knc.svg": 1311,
	"./kp3r.svg": 47845,
	"./krb.svg": 84466,
	"./ksm.svg": 85382,
	"./kuji.svg": 97100,
	"./lbc.svg": 7440,
	"./lcx.svg": 2824,
	"./ldo.svg": 74586,
	"./lend.svg": 8144,
	"./leo.svg": 78805,
	"./link.svg": 11323,
	"./lit.svg": 66842,
	"./lkk.svg": 63875,
	"./loom.svg": 19700,
	"./lpt.svg": 11893,
	"./lqty.svg": 76359,
	"./lrc.svg": 63296,
	"./lsd.svg": 55708,
	"./lsk.svg": 6971,
	"./ltc-det.svg": 45542,
	"./ltc.svg": 62494,
	"./lun.svg": 9252,
	"./luna.svg": 43949,
	"./lunc.svg": 19583,
	"./lusd.svg": 67807,
	"./maid.svg": 38922,
	"./mana.svg": 26417,
	"./mask.svg": 42043,
	"./matic.svg": 48239,
	"./max.svg": 14171,
	"./mc.svg": 93219,
	"./mcap.svg": 81112,
	"./mco.svg": 4558,
	"./mco2.svg": 25088,
	"./mcu.svg": 57844,
	"./mda.svg": 27061,
	"./mds.svg": 1495,
	"./med.svg": 9163,
	"./meetone.svg": 81042,
	"./meme.svg": 29459,
	"./metis.svg": 38827,
	"./mft.svg": 60254,
	"./mim.svg": 926,
	"./mina.svg": 97254,
	"./miota.svg": 50521,
	"./mir.svg": 53449,
	"./mith.svg": 35069,
	"./mkr.svg": 53603,
	"./mln.svg": 33802,
	"./mnt.svg": 82726,
	"./mnx.svg": 16834,
	"./mnz.svg": 40320,
	"./moac.svg": 81631,
	"./mobile.svg": 75837,
	"./mod.svg": 96201,
	"./mog.svg": 81114,
	"./mona.svg": 34440,
	"./money.svg": 93637,
	"./mpl.svg": 33476,
	"./msol.svg": 73766,
	"./msr.svg": 75531,
	"./mth.svg": 78764,
	"./mtl.svg": 91904,
	"./music.svg": 81116,
	"./mx.svg": 87320,
	"./mzc.svg": 90197,
	"./nano.svg": 39941,
	"./nas.svg": 70059,
	"./nav.svg": 63494,
	"./ncash.svg": 92690,
	"./ndz.svg": 47941,
	"./near.svg": 9317,
	"./nebl.svg": 54,
	"./neo.svg": 70699,
	"./neos.svg": 7426,
	"./neu.svg": 39489,
	"./nexo.svg": 65243,
	"./ngc.svg": 8841,
	"./nio.svg": 13111,
	"./nkn.svg": 21624,
	"./nlc2.svg": 74350,
	"./nlg.svg": 29672,
	"./nmc.svg": 60247,
	"./nmr.svg": 91094,
	"./nos.svg": 19537,
	"./npxs.svg": 95482,
	"./ntbc.svg": 5012,
	"./nuls.svg": 26587,
	"./nxm.svg": 95302,
	"./nxs.svg": 15888,
	"./nxt.svg": 65423,
	"./oax.svg": 77221,
	"./ocean.svg": 85811,
	"./ogn.svg": 7589,
	"./ok.svg": 45013,
	"./okt.svg": 29091,
	"./om.svg": 82171,
	"./omg.svg": 95054,
	"./omni.svg": 74716,
	"./one.svg": 97925,
	"./ong.svg": 71479,
	"./ont.svg": 75412,
	"./oot.svg": 19063,
	"./op.svg": 27566,
	"./orca.svg": 73556,
	"./ordi.svg": 94849,
	"./osmo.svg": 76217,
	"./ost.svg": 8779,
	"./ox.svg": 27910,
	"./oxt.svg": 47222,
	"./paal.svg": 33533,
	"./part.svg": 30668,
	"./pasc.svg": 45664,
	"./pasl.svg": 21143,
	"./pax.svg": 30346,
	"./paxg.svg": 45353,
	"./pay.svg": 82811,
	"./payx.svg": 98265,
	"./pendle.svg": 18037,
	"./pepe.svg": 62063,
	"./pi.svg": 98326,
	"./pink.svg": 7663,
	"./pirl.svg": 48380,
	"./pivx.svg": 91956,
	"./pixel.svg": 13757,
	"./pla.svg": 78944,
	"./plr.svg": 75139,
	"./poa.svg": 26281,
	"./poe.svg": 35621,
	"./pokt.svg": 74469,
	"./pol.svg": 62252,
	"./polis.svg": 9764,
	"./poly.svg": 76669,
	"./polyx.svg": 73967,
	"./pond.svg": 7134,
	"./popcat.svg": 34476,
	"./portal.svg": 25921,
	"./pot.svg": 57684,
	"./powr.svg": 34631,
	"./ppc.svg": 92974,
	"./ppp.svg": 47709,
	"./ppt.svg": 18817,
	"./pre.svg": 31242,
	"./prime.svg": 34728,
	"./prl.svg": 98627,
	"./prom.svg": 19221,
	"./pungo.svg": 24962,
	"./pura.svg": 99061,
	"./pyth.svg": 23890,
	"./pyusd.svg": 98742,
	"./qash.svg": 78084,
	"./qiwi.svg": 2985,
	"./qlc.svg": 26619,
	"./qnt.svg": 1978,
	"./qrdo.svg": 66101,
	"./qrl.svg": 62886,
	"./qsp.svg": 33069,
	"./qtum.svg": 45010,
	"./r.svg": 31991,
	"./rad.svg": 54256,
	"./rads.svg": 68211,
	"./rap.svg": 68940,
	"./rare.svg": 4015,
	"./ray.svg": 25477,
	"./rbn.svg": 21907,
	"./rcn.svg": 69436,
	"./rdd.svg": 88295,
	"./rdn.svg": 74717,
	"./ren.svg": 15918,
	"./rep.svg": 19464,
	"./repv2.svg": 44600,
	"./req.svg": 84857,
	"./reth.svg": 34804,
	"./revv.svg": 53156,
	"./rhoc.svg": 24883,
	"./ric.svg": 38631,
	"./rif.svg": 65994,
	"./rise.svg": 79048,
	"./rlb.svg": 91057,
	"./rlc.svg": 50496,
	"./rly.svg": 68522,
	"./rndr.svg": 1293,
	"./rose.svg": 10954,
	"./rpl.svg": 9851,
	"./rpx.svg": 96151,
	"./rsr.svg": 51752,
	"./rss3.svg": 47608,
	"./rub.svg": 55722,
	"./rune.svg": 84575,
	"./rvn.svg": 7623,
	"./ryo.svg": 8147,
	"./safe.svg": 77328,
	"./safemoon.svg": 80539,
	"./sai.svg": 20712,
	"./salt.svg": 9475,
	"./samo.svg": 39995,
	"./san.svg": 41959,
	"./sand.svg": 57257,
	"./sats.svg": 32900,
	"./sbd.svg": 97524,
	"./sberbank.svg": 27063,
	"./sbr.svg": 29210,
	"./sc.svg": 93865,
	"./sei.svg": 63324,
	"./sfp.svg": 28988,
	"./sfrxeth.svg": 90959,
	"./sfund.svg": 8547,
	"./shdw.svg": 30497,
	"./shib.svg": 82407,
	"./shift.svg": 63261,
	"./sib.svg": 53179,
	"./sin.svg": 69039,
	"./skl.svg": 55399,
	"./sky.svg": 38874,
	"./slp.svg": 56578,
	"./slr.svg": 64672,
	"./sls.svg": 27473,
	"./smart.svg": 3142,
	"./sngls.svg": 26172,
	"./snm.svg": 92305,
	"./snt.svg": 30376,
	"./snx.svg": 9500,
	"./soc.svg": 27700,
	"./sol.svg": 84739,
	"./spacehbit.svg": 86198,
	"./spank.svg": 30722,
	"./spell.svg": 27051,
	"./sphtx.svg": 73722,
	"./srn.svg": 50254,
	"./ssv.svg": 1381,
	"./stak.svg": 80538,
	"./start.svg": 21685,
	"./steem.svg": 87837,
	"./storj.svg": 3333,
	"./storm.svg": 96154,
	"./stox.svg": 14511,
	"./stq.svg": 72267,
	"./strat.svg": 919,
	"./strd.svg": 73012,
	"./strk.svg": 30051,
	"./stsol.svg": 93856,
	"./stx.svg": 74114,
	"./sub.svg": 70711,
	"./sui.svg": 99500,
	"./sumo.svg": 13623,
	"./sushi.svg": 57031,
	"./sweth.svg": 79446,
	"./sxp.svg": 7502,
	"./sys.svg": 52746,
	"./t.svg": 12425,
	"./taas.svg": 47798,
	"./tao.svg": 96545,
	"./tau.svg": 27755,
	"./tbx.svg": 16611,
	"./tel.svg": 4430,
	"./ten.svg": 53836,
	"./tern.svg": 55502,
	"./tfuel.svg": 20861,
	"./tgch.svg": 24709,
	"./theta.svg": 82417,
	"./tia.svg": 53887,
	"./tix.svg": 1206,
	"./tkn.svg": 24102,
	"./tks.svg": 1731,
	"./tkx.svg": 43976,
	"./tnb.svg": 66773,
	"./tnc.svg": 41140,
	"./tnt.svg": 95883,
	"./toke.svg": 71104,
	"./tomo.svg": 68116,
	"./ton.svg": 45698,
	"./tpay.svg": 10521,
	"./trac.svg": 66789,
	"./trb.svg": 40537,
	"./trig.svg": 41793,
	"./trtl.svg": 38241,
	"./tru.svg": 12742,
	"./trx.svg": 79347,
	"./tusd.svg": 48503,
	"./twt.svg": 47648,
	"./tzc.svg": 86880,
	"./u.svg": 53272,
	"./ubq.svg": 43271,
	"./uma.svg": 65254,
	"./uni.svg": 61899,
	"./unity.svg": 30510,
	"./unknown-icon.svg": 78095,
	"./usd.svg": 55933,
	"./usdc.svg": 42212,
	"./usdd.svg": 4363,
	"./usde.svg": 85306,
	"./usdt.svg": 99035,
	"./ust.svg": 55437,
	"./utk.svg": 94103,
	"./veri.svg": 30528,
	"./vet.svg": 95128,
	"./via.svg": 13801,
	"./vib.svg": 52634,
	"./vibe.svg": 79867,
	"./vivo.svg": 29597,
	"./vrc.svg": 83594,
	"./vrsc.svg": 9973,
	"./vtc.svg": 45108,
	"./vtho.svg": 87978,
	"./wabi.svg": 28348,
	"./wan.svg": 87763,
	"./waves.svg": 84807,
	"./wax.svg": 25405,
	"./waxp.svg": 60199,
	"./wbeth.svg": 18581,
	"./wbt.svg": 13312,
	"./wbtc.svg": 23859,
	"./wcfg.svg": 50044,
	"./wemix.svg": 71959,
	"./wgr.svg": 64649,
	"./wicc.svg": 22993,
	"./wings.svg": 48753,
	"./wpr.svg": 90312,
	"./wtc.svg": 17749,
	"./x.svg": 12589,
	"./xas.svg": 44105,
	"./xaut.svg": 4137,
	"./xbc.svg": 92844,
	"./xbp.svg": 22927,
	"./xby.svg": 46486,
	"./xch.svg": 46631,
	"./xcp.svg": 90988,
	"./xdc.svg": 69570,
	"./xdn.svg": 14615,
	"./xec.svg": 62661,
	"./xem.svg": 23187,
	"./xin.svg": 48004,
	"./xlm.svg": 98956,
	"./xmcc.svg": 84388,
	"./xmg.svg": 80865,
	"./xmo.svg": 63929,
	"./xmr.svg": 4428,
	"./xmy.svg": 18167,
	"./xp.svg": 92855,
	"./xpa.svg": 35924,
	"./xpm.svg": 26864,
	"./xpr.svg": 29111,
	"./xrd.svg": 84771,
	"./xrp.svg": 35231,
	"./xsg.svg": 42515,
	"./xtz.svg": 40971,
	"./xuc.svg": 34274,
	"./xvc.svg": 38232,
	"./xvg.svg": 14916,
	"./xzc.svg": 72660,
	"./yfi.svg": 81423,
	"./ygg.svg": 7486,
	"./yoyow.svg": 18458,
	"./zbc.svg": 58542,
	"./zcl.svg": 67062,
	"./zec.svg": 26387,
	"./zel.svg": 63108,
	"./zen.svg": 28582,
	"./zest.svg": 59605,
	"./zil.svg": 24984,
	"./zilla.svg": 1941,
	"./zrx.svg": 6661
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 74595;